export default __webpack_public_path__ + "static/media/edited-28.5bfde3d9.jpg";